module.exports = "pegasus/assets/tech/basic_2/1.png";